$(document).ready(function () {

    let dotAnimate = $('.main-chart__dot-item'),
        counterData;

    dotAnimate.each((index, element) => {
        counterData = $(element).data("speed-animate");
        startAnimation(counterData, element);
    });

    function startAnimation(timeout, element) {
        setTimeout(function () {
            $(element).addClass('main-chart__dot-item--animate');

        }, timeout);
    }
});

if (Array.from(document.querySelectorAll('.main-chart__full-background--full')).length > 0) {
    let $mainChartBackFull = document.querySelector('.main-chart__full-background--full');
    $mainChartBackFull.addEventListener('load', () => {
        let $small = document.querySelector('.main-chart__full-background--small');
        $small.style.opacity = 0;
        $mainChartBackFull.style.opacity = 1;
    });
}

